define( [
	"../Data"
], function( Data ) {
	"use strict";

	return new Data();
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/data/var/dataUser.js
// module id = ukCe
// module chunks = 0 1